// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* LicenseUnits page styles */
`, "",{"version":3,"sources":["webpack://./src/pages/LicenseManagement/LicenseUnits/LicenseUnits.css"],"names":[],"mappings":"AAAA,6BAA6B","sourcesContent":["/* LicenseUnits page styles */\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
